import React from 'react'
import { RadioGroup, Stack, Typography } from '@mui/material'
import { Question, QuestionFrameContext, RadioItems } from 'components/questions'
import { useGlobalState } from 'state'


type FixedRadioQuestionProps = {
  num: number
  content: string
}

export const FixedRadioQuestion = ({ num, content }: FixedRadioQuestionProps) => {
  const state = useGlobalState()
  const q = React.useContext(QuestionFrameContext)

  const answerValue = React.useMemo(() => {
    const answer = state.app.getAnswer(q, num)
    return answer !== null ? answer.value : {assessment1: '', assessment2: '', assessment3: ''}
  }, [state.app.answers])

  const update = (field: string, updateValue: string) => {
    const data = {
      ...answerValue,
      [field]: updateValue
    }
    let valid = !data.assessment1 || !data.assessment2 || !data.assessment3  ? false : true
    if (isIgnore2(data) === true && data.assessment1 !== '') {
      data.assessment2 = ''
      data.assessment3 = ''
      valid = true
    } else if (isIgnore3(data) === true && data.assessment2 !== '') {
      data.assessment3 = ''
      valid = true
    }
    state.app.updateAnswer(q, num, data, valid)
  }

  const isIgnore2 = (a: any): boolean => {
    if (a === null) return false
    return ['設備が無い', '最大浸水位より上にある', ''].includes(a.assessment1)
  }

  const isIgnore3 = (a: any): boolean => {
    if (a === null) return false
    if (isIgnore2(a) === true) {
      return true
    }
    if (['水防ラインがない', '水防ラインの外側にある', ''].includes(a.assessment2)) {
      return true
    } else {
      return false
    }
  }

  return (
    <Question num={num} content={content}>
      <Stack direction='column' spacing={2}>

        <Typography variant='body2' sx={{textDecoration: 'underline'}}>{'設置高さ評価'}</Typography>
        <RadioGroup style={{marginTop: 0}} row value={answerValue.assessment1} onChange={(e) => update('assessment1', (e.target as HTMLInputElement).value)}>
          <RadioItems items={state.scoring.getRadioItems('q8-q9-1')} />
        </RadioGroup>

        { isIgnore2(answerValue) === false && (
          <>
            <Typography variant='body2' sx={{textDecoration: 'underline'}}>{'水防ライン平面評価'}</Typography>
            <RadioGroup style={{marginTop: 0}} row value={answerValue.assessment2} onChange={(e) => update('assessment2', (e.target as HTMLInputElement).value)}>
              <RadioItems items={state.scoring.getRadioItems('q8-q9-2')} />
            </RadioGroup>
          </>
        ) }

        { isIgnore3(answerValue) === false && (
          <>
            <Typography variant='body2' sx={{textDecoration: 'underline'}}>{'水防ライン高さ評価'}</Typography>
            <RadioGroup style={{marginTop: 0}} row value={answerValue.assessment3} onChange={(e) => update('assessment3', (e.target as HTMLInputElement).value)}>
              <RadioItems items={state.scoring.getRadioItems('q8-q9-3')} />
            </RadioGroup>
          </>
        ) }

      </Stack>
    </Question>
  )
}
